var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Marcas de autos","storeName":"Car_brands","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","next-link":"/admin/type_spots","breadcrumbs":[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/car_brands'
      },
      {
        text: 'Marcas de autos',
        disabled: false,
        href: '#'
      },
    ]},scopedSlots:_vm._u([{key:"car_models",fn:function({ item }){return [_c('v-btn',{staticClass:"my-1 btn-black btn-round-md",attrs:{"elevation":"0","rounded":"","color":"primary"},on:{"click":function($event){return _vm.$router.push('/admin/car_brands/' + item.id + '/car_models')}}},[_vm._v(" Modelos ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }